export const SERVICES = [
  {
    id: "itr-filing",
    name: "ITR Filed & verified by CA",
    price: "\u20b91,099/-*",
    priceValue: 1099,
    description:
      "Professional ITR filing by experienced Chartered Accountants for salaried individuals, freelancers, and business owners.",
    features: [
      "In 4* Days",
      "Filed by a CA ONLY",
      "Maximum Refund",
      "IT Notice Support",
    ],
    icon: "FileText",
    workflowSteps: [
      "Documents",
      "Payment",
      "Computation",
      "Draft ITR",
      "Virtual Meeting",
      "Approval",
      "Filed ITR",
      "Deliverables",
    ],
  },
  {
    id: "virtual-accountant",
    name: "Virtual Accountant",
    price: "\u20b910,000/-",
    priceValue: 10000,
    description:
      "Dedicated virtual accountant who handles your books monthly — bookkeeping, reconciliation, and financial statements.",
    features: [
      "Monthly",
      "Daily Accounting",
      "P&L Report",
      "Cashflow Statement",
    ],
    icon: "Monitor",
    workflowSteps: [
      "Documents",
      "Payments",
      "Setup",
      "Onboarding",
      "Monthly Review",
      "Reporting",
      "Compliance",
      "Deliverables",
    ],
  },
  {
    id: "company-incorporation",
    name: "Incorporation Of Company",
    price: "\u20b915,000/-",
    priceValue: 15000,
    description:
      "End-to-end Private Limited Company incorporation — from name reservation to Certificate of Incorporation.",
    features: [
      "In 7* Days",
      "Name Approval",
      "Shareholder Agreement",
      "Custom MOA & AOA",
    ],
    icon: "Building",
    workflowSteps: [
      "Documents",
      "Payment",
      "Name Approval",
      "DSC & DIN",
      "Drafting",
      "MCA Filing",
      "Approval",
      "Deliverables",
      "Post Incorporation Compliance",
      "Company Documents",
    ],
  },
  {
    id: "llp-incorporation",
    name: "Incorporation Of LLP",
    price: "\u20b910,000/-",
    priceValue: 10000,
    description:
      "Quick LLP registration with expert guidance — ideal for partnerships wanting limited liability protection.",
    features: [
      "In 7* Days",
      "Name Approval",
      "Legally Vetted LLP Deed",
      "MCA Compliance",
    ],
    icon: "Users",
    workflowSteps: [
      "Documents",
      "Payment",
      "Name Approval",
      "DSC & DPIN",
      "LLP Agreement",
      "MCA Filing",
      "Approval",
      "Deliverables",
    ],
  },
  {
    id: "loans",
    name: "Loans, Mudra, CGTMSE",
    price: "1% Of Loan Funded",
    priceValue: 0,
    description:
      "Business loan facilitation — Mudra, CGTMSE, term loans, working capital. We handle bank liaison end-to-end.",
    features: [
      "In 15* Days",
      "Project Report / Deck",
      "Bank Recommendation",
      "Liaison Support",
    ],
    icon: "Banknote",
    workflowSteps: [
      "Documents",
      "Payment",
      "Assessment",
      "Approval Status",
      "Sanction Letter",
      "Disbursement",
    ],
  },
  {
    id: "cfo-services",
    name: "CFO Services",
    price: "Starts from \u20b930,000/-",
    priceValue: 30000,
    description:
      "Virtual CFO for growing businesses — financial strategy, MIS reporting, cash flow management, and investor readiness.",
    features: [
      "Board Ready Strategy",
      "Real Time Dashboards",
      "Predictive Cashflow",
      "Design of SOPs",
    ],
    icon: "TrendingUp",
    workflowSteps: [
      "Documents",
      "Payment",
      "Assessment",
      "Strategy",
      "Implementation",
      "Monthly Review",
      "Reporting",
      "Deliverables",
    ],
  },
  {
    id: "insurance",
    name: "Insurance For Business",
    price: "Quote Based",
    priceValue: 15000,
    description:
      "Comprehensive business insurance — professional liability, D&O, cyber, fire, marine, and workmen's compensation.",
    features: [
      "Lowest Premium",
      "Proactive Risk Mapping",
      "Industry Specific Cover",
      "Claims Support",
    ],
    icon: "Shield",
    workflowSteps: [
      "Documents",
      "Payment",
      "Assessment",
      "Proposal",
      "Comparison",
      "Selection",
      "Policy Insurance",
      "Deliverables",
    ],
  },
  {
    id: "gst-filings",
    name: "GST Filings",
    price: "Starts from \u20b91,099/-",
    priceValue: 1099,
    description:
      "Timely and accurate GST return filing — GSTR-1, GSTR-3B, annual returns, and ITC reconciliation.",
    features: [
      "On Time Returns",
      "ITC Maximised",
      "GST Notice Ready",
      "Monthly Reconciliations",
    ],
    icon: "Receipt",
    workflowSteps: [
      "Documents",
      "Payment",
      "Data Entry",
      "ITC Reconciliation",
      "Review",
      "Filing",
      "Acknowledgment",
      "Deliverables",
    ],
  },
  {
    id: "trademarks",
    name: "Trademarks & Patents",
    price: "Starts from \u20b910,000/-",
    priceValue: 10000,
    description:
      "Protect your brand — trademark search, application filing, objection handling, and registration certificate.",
    features: [
      "Strong Brand Protection",
      "Faster Filings Worldwide",
      "Office Actions Managed",
      "Portfolio Monitoring Alerts",
    ],
    icon: "Award",
    workflowSteps: [
      "Documents",
      "Payment",
      "TM Search",
      "Application Filing",
      "Examination",
      "Publication",
      "Registration",
      "Deliverables",
    ],
  },
  {
    id: "labour-compliance",
    name: "Labour Law Compliance",
    price: "Starts from \u20b95,000/-",
    priceValue: 5000,
    description:
      "Complete labour law compliance — PF & ESI registration, monthly/annual returns, and inspection support.",
    features: [
      "Statutory Registers",
      "On Time Remittances",
      "Confident Inspections",
      "Employee Records",
    ],
    icon: "HardHat",
    workflowSteps: [
      "Documents",
      "Payment",
      "Assessment",
      "Registration",
      "Monthly Filing",
      "Annual Returns",
      "Compliance Audit",
      "Deliverables",
    ],
  },
  {
    id: "ca-consulting",
    name: "CA Consulting",
    price: "Starts from \u20b92,500/-",
    priceValue: 2500,
    description:
      "Expert CA consultation for tax planning, business restructuring, due diligence, M&A advisory, and complex matters.",
    features: [
      "Expert Advisory",
      "Tax Consulting",
      "Tax Savings & Planning",
      "Data Driven Decisions",
    ],
    icon: "MessageSquare",
    workflowSteps: [
      "Payment",
      "Documents",
      "Analysis",
      "Consultation",
      "Opinion Draft",
      "Virtual Meeting",
      "Final Opinion",
      "Deliverables",
    ],
  },
  {
    id: "everything-money",
    name: "Everything Related Money",
    price: "Quote Based",
    priceValue: 15000,
    description:
      "Can't find what you need? Tell us your requirement — financial planning, investment advisory, FEMA, NRI taxation, anything.",
    features: [
      "Treasury Optimisation",
      "Funding Readiness",
      "Cost Control Systems",
      "Investor Grade Reporting",
    ],
    icon: "IndianRupee",
    workflowSteps: [
      "Payment",
      "Documents",
      "Scope Definition",
      "Assessment",
      "Execution",
      "Review",
      "Approval",
      "Deliverables",
    ],
  },
];

export const STEP_NAME_TO_ROUTE = {
  Documents: "documents",
  Payment: "payment",
  Computation: "computation",
  Assessment: "computation",
  Analysis: "computation",
  "Data Entry": "computation",
  "ITC Reconciliation": "computation",
  "Draft ITR": "draft",
  Drafting: "meeting",
  Draft: "draft",
  Proposal: "draft",
  Strategy: "draft",
  Consultation: "draft",
  Onboarding: "draft",
  Application: "draft",
  "Agreement Draft": "draft",
  Planning: "draft",
  "Scope Definition": "draft",
  "Opinion Draft": "draft",
  "DSC & DIN": "draft",
  "DSC & DPIN": "draft",
  "TM Search": "draft",
  "Application Filing": "filing",
  "Virtual Meeting": "meeting",
  "Monthly Review": "meeting",
  Review: "meeting",
  Examination: "meeting",
  "Bank Liaison": "meeting",
  Implementation: "meeting",
  "LLP Agreement": "meeting",
  Comparison: "meeting",
  "Name Approval": "name-approval",
  "MCA Filing": "mca-filing",
  Approval: "status",
  "itr-filing:Approval": "approval",
  "Approval Status": "status",
  Setup: "status",
  Reporting: "status",
  Filing: "status",
  "Filed ITR": "status",
  Acknowledgment: "status",
  "Monthly Filing": "status",
  "Annual Returns": "status",
  "Compliance Audit": "status",
  "Final Opinion": "status",
  Execution: "status",
  Selection: "approval",
  "Sanction Letter": "approval",
  "Policy Insurance": "status",
  Publication: "publication",
  Registration: "registration",
  Disbursement: "deliverables",
  Deliverables: "deliverables",
  "Post Incorporation Compliance": "compliance",
  "Company Documents": "company-docs",
};

export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Chandigarh",
  "Puducherry",
  "Andaman & Nicobar Islands",
  "Dadra & Nagar Haveli",
  "Lakshadweep",
];
